import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	reloadStudy(target) {
		self.location = target.options[target.selectedIndex].value;
	}

	connect() {
		this.element.onchange = (event) => this.reloadStudy(event.currentTarget);
	}
}
